import { Notification } from './types'
import { NotificationType } from 'types'

import { CommentNotification } from './NotificationTypes/CommentNotification/CommentNotification'
import { TodoNotification } from './NotificationTypes/TodoNotification/TodoNotification'
import { GroupNotification } from './NotificationTypes/GroupNotification'
import { InformalFeedbackRequestNotification } from './NotificationTypes/InformalFeedbackRequestNotification/InformalFeedbackRequestNotification'
import { AccessRequestArticleNotification } from './NotificationTypes/AccessRequestNotification/AccessRequestArticleNotification'
import { AccessRequestFolderNotification } from './NotificationTypes/AccessRequestNotification/AccessRequestFolderNotification'
import { AccessGrantNotification } from './NotificationTypes/AccessGrantNotification'
import { OwnershipTransferNotification } from './NotificationTypes/OwnershipTransferNotification'

interface Props {
  notification: Notification
  onClose: () => void
}

export const NotificationItem = (props: Props) => {
  const { notification } = props

  switch (notification.subject_type) {
    case NotificationType.Comment:
      return <CommentNotification {...props} notification={notification} />

    case NotificationType.Todo:
      return <TodoNotification {...props} notification={notification} />

    case NotificationType.GroupMembership:
      return <GroupNotification {...props} notification={notification} />

    case NotificationType.InformalFeedbackRequest:
      return <InformalFeedbackRequestNotification {...props} notification={notification} />

    case NotificationType.AccessRequest:
      if ('folder' in notification) {
        return <AccessRequestFolderNotification {...props} notification={notification} />
      }

      return <AccessRequestArticleNotification {...props} notification={notification} />
    case NotificationType.AccessGrant:
      return <AccessGrantNotification {...props} notification={notification} />

    case NotificationType.OwnershipTransfer:
      return <OwnershipTransferNotification {...props} notification={notification} />

    default:
      return null
  }
}
